"use client";

import {
  isMygaPrivatePath,
  isMygaPrivateUrl,
} from "@/lib/myga-application/privacy";
import { AppRUM } from "@/lib/observability/AppRUM";
import { useAppPathname } from "@/ui/app-link/app-link";

export function CharmRUM() {
  const pathname = useAppPathname();
  return (
    <AppRUM
      app="charm"
      disabled={isMygaPrivatePath(pathname)}
      isPrivateUrl={isMygaPrivateUrl}
    />
  );
}
